/* Elm & Tail — minimal interaction layer.
   Scroll reveals + sticky add-to-cart. No dependencies. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.et-reveal:not(.et-in)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('et-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('et-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initStickyAtc() {
    var bar = document.querySelector('.et-sticky-atc');
    var anchor = document.querySelector('.product-form__submit');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('et-sticky-atc--visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    io.observe(anchor);
    var trigger = bar.querySelector('[data-et-sticky-submit]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        anchor.click();
      });
    }
  }

  function init() {
    initReveals();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initReveals);
})();
